import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaUpload as Upload } from 'react-icons/fa';
import { IoSearchSharp as ZoomIn, IoCrop as Crop, IoImageSharp as FileImage, IoGrid as Grid } from 'react-icons/io5';

export default function ToolSelector({ activeTool, selectedImage, handleToolChange, showToolTip }) {
  const { t } = useTranslation();
  return (
    <div className="mb-8 transform transition-all duration-300 hover:shadow-md bg-white p-3 rounded-xl mx-auto inline-block">
      <div className="flex flex-wrap gap-1 md:gap-2 justify-center">
        <button
          onClick={() => handleToolChange('upload')}
          onMouseEnter={(e) => showToolTip(t('tool.selector.upload.tooltip'), e)}
          className={`p-3 rounded-lg flex flex-col items-center transition-all duration-400 transform hover:scale-105 ${
            activeTool === 'upload' ? 'bg-blue-600 text-white shadow-lg' : 'bg-gray-50 hover:bg-gray-100 text-gray-700 hover:shadow'
          }`}
          aria-label={t('tool.selector.upload.aria')}
        >
          <Upload size={22} />
        </button>

        <button
          onClick={() => selectedImage && handleToolChange('scale')}
          disabled={!selectedImage}
          onMouseEnter={(e) => selectedImage && showToolTip(t('tool.selector.scale.tooltip'), e)}
          className={`p-3 rounded-lg flex flex-col items-center transition-all duration-400 transform hover:scale-105 ${
            !selectedImage
              ? 'bg-gray-50 text-gray-400 cursor-not-allowed'
              : activeTool === 'scale'
              ? 'bg-blue-600 text-white shadow-lg'
              : 'bg-gray-50 hover:bg-gray-100 text-gray-700 hover:shadow'
          }`}
          aria-label={t('tool.selector.scale.aria')}
        >
          <ZoomIn size={22} />
        </button>

        <button
          onClick={() => selectedImage && handleToolChange('crop')}
          disabled={!selectedImage}
          onMouseEnter={(e) => selectedImage && showToolTip(t('tool.selector.crop.tooltip'), e)}
          className={`p-3 rounded-lg flex flex-col items-center transition-all duration-400 transform hover:scale-105 ${
            !selectedImage
              ? 'bg-gray-50 text-gray-400 cursor-not-allowed'
              : activeTool === 'crop'
              ? 'bg-blue-600 text-white shadow-lg'
              : 'bg-gray-50 hover:bg-gray-100 text-gray-700 hover:shadow'
          }`}
          aria-label={t('tool.selector.crop.aria')}
        >
          <Crop size={22} />
        </button>

        <button
          onClick={() => selectedImage && handleToolChange('format')}
          disabled={!selectedImage}
          onMouseEnter={(e) => selectedImage && showToolTip(t('tool.selector.format.tooltip'), e)}
          className={`p-3 rounded-lg flex flex-col items-center transition-all duration-400 transform hover:scale-105 ${
            !selectedImage
              ? 'bg-gray-50 text-gray-400 cursor-not-allowed'
              : activeTool === 'format'
              ? 'bg-blue-600 text-white shadow-lg'
              : 'bg-gray-50 hover:bg-gray-100 text-gray-700 hover:shadow'
          }`}
          aria-label={t('tool.selector.format.aria')}
        >
          <FileImage size={22} />
        </button>

        <button
          onClick={() => handleToolChange('grid')}
          onMouseEnter={(e) => showToolTip(t('tool.selector.grid.tooltip'), e)}
          className={`p-3 rounded-lg flex flex-col items-center transition-all duration-400 transform hover:scale-105 ${
            activeTool === 'grid' ? 'bg-blue-600 text-white shadow-lg' : 'bg-gray-50 hover:bg-gray-100 text-gray-700 hover:shadow'
          }`}
          aria-label={t('tool.selector.grid.aria')}
        >
          <Grid size={22} />
        </button>
      </div>
    </div>
  );
}